import { api } from '@/lib/api'

/**
 * @typedef {{
 *   enabled: boolean,
 *   earn_rate: number,
 *   redeem_rate: number,
 *   min_redeem_points: number,
 * }} LoyaltySettings
 */

/**
 * @returns {Promise<LoyaltySettings>}
 */
export async function fetchLoyaltySettings() {
  const { data } = await api.get('/masters/loyalty-settings')
  return data.data.loyalty_settings
}

/**
 * @param {Partial<LoyaltySettings>} payload
 * @returns {Promise<LoyaltySettings>}
 */
export async function updateLoyaltySettings(payload) {
  const { data } = await api.put('/masters/loyalty-settings', payload)
  return data.data.loyalty_settings
}
